







import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "@/main";
import { StoreReports, StoreAuthentication } from "./store";
import { AlertController } from "@ionic/vue/dist/types/controllers";
import { OverlayController, AlertOptions } from "@ionic/core";
import LoginForm from "@/components/LoginForm.vue";

@Component
export default class App extends Vue {
  public onlineCheckerIntervalID: number | null = null;

  public initOnlineChecker() {
    this.onlineCheckerIntervalID = window.setInterval(() => {
      if (navigator.onLine) {
        if (this.onlineCheckerIntervalID) {
          window.clearInterval(this.onlineCheckerIntervalID);
          this.onlineCheckerIntervalID = null;
        }
      }
    }, 50000);
  }

  public showLoginPane() {
    return this.$ionic.modalController
      .create({
        component: LoginForm,
        componentProps: {
          parent: this,
          propsData: {
            dismissModal: () => {
              this.$ionic.modalController.dismiss();
            }
          }
        }
      })
      .then(m => {
        m.present();
      });
  }

  public dirtyFormAlert(viewVue: any, formVue: any): any {
    const opts: AlertOptions = {
      header: "Daten Speichern",
      message: "Möchten Sie die Daten speichern?",
      buttons: [
        {
          text: "Nein",
          handler: () => {
            viewVue.formCancel();
          }
        },
        {
          text: "Ja",
          handler: () => {
            formVue.save();
          }
        }
      ]
    };
    return this.$ionic.alertController.create(opts).then(a => a.present());
  }

  public deleteListItemAlert(viewVue: any, recordId: string): any {
    const opts: AlertOptions = {
      header: "Eintrag löschen",
      subHeader: "Möchten Sie den Datensatz wirklich entfernen?",
      message: "Dies kann nicht rückgängig gemacht werden!",
      buttons: [
        {
          text: "Nein",
          handler: () => {
            viewVue.deleteCancel(recordId);
          }
        },
        {
          text: "Ja",
          handler: () => {
            viewVue.deleteItem(recordId);
          }
        }
      ]
    };
    return this.$ionic.alertController.create(opts).then(a => a.present());
  }

  public saveOfflineItemAlert(viewVue: any, recordId: string): any {
    let opts: AlertOptions;
    if (navigator.onLine) {
      opts = {
        header: "Eintrag senden",
        subHeader: "Die Daten werden auf dem Zielsystem gesichert.",
        message:
          "Momentan befindet sich der Eintrag nur offline auf ihrem Mobilgerät.",
        buttons: [
          {
            text: "Nein",
            handler: () => {
              return true;
            }
          },
          {
            text: "Ja",
            handler: () => {
              viewVue.saveOfflineItemAction(recordId);
            }
          }
        ]
      };
    } else {
      opts = {
        header: "Keine WLAN Verbindung!",
        subHeader:
          "Neue Einträge können nur bei stabilem WLAN ans Zielsystem gesendet werden.",
        message:
          "Wechseln Sie zu einem Standort mit WLAN Verbindung zum Zielsystem.",
        buttons: ["OK"]
      };
    }
    return this.$ionic.alertController.create(opts).then(a => a.present());
  }

  protected mounted() {
    this.$nextTick(() => {
      StoreAuthentication.currentAuthToken().then(authToken => {
        if (!authToken) {
          this.showLoginPane();
        }
      });
    });
    EventBus.$on("offline", this.initOnlineChecker);
    EventBus.$on("authError", this.showLoginPane);
    EventBus.$on("dirtyForm", this.dirtyFormAlert);
    EventBus.$on("deleteListItem", this.deleteListItemAlert);
    EventBus.$on("saveOfflineItem", this.saveOfflineItemAlert);
  }
}
